// Export event emitter functions
export { emitTelemetryEvent, emitDisplaySubmission, CORRELATION_ID_KEY } from './lib/event-emitter';

// Export event type interfaces
export type { SearchEvent, TelemetryEvent, DisplaySubmissionEvent } from './lib/types';

// Export type aliases for search categorization
export type { SearchType, SearchSource } from './lib/types';
